import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { DataService } from "@/services/data";
import { ApprenticeshipAppointmentType } from "@/types/apprenticeship/enterprise";
import { NotebookPen } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export function AppointmentCommentDialog({ appointment, size = 20, children }: { appointment: ApprenticeshipAppointmentType; size?: number; children?: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [comment, setComment] = useState<string>(appointment?.comment ?? "");
    const navigate = useNavigate();

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger
                asChild
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                {children || <NotebookPen width={size} height={size} cursor="pointer" />}
            </DialogTrigger>
            <DialogContent className={"max-h-dvh w-full max-w-screen-sm overflow-auto"}>
                <DialogHeader>
                    <DialogTitle>Modifier le commentaire</DialogTitle>
                </DialogHeader>

                <Label htmlFor="comment">Commentaire</Label>
                <Textarea id="comment" placeholder="Ajouter un commentaire" value={comment} onChange={e => setComment(e.target.value)} />

                <DialogFooter>
                    <Button variant="outline" onClick={() => setIsOpen(false)}>
                        Annuler
                    </Button>
                    <Button
                        type="button"
                        onClick={() => {
                            DataService.client
                                .url(`/apprenticeship/appointments/${appointment.id}/`)
                                .patch({
                                    comment
                                })
                                .json()
                                .then(() => {
                                    toast.success("Commentaire modifié avec succès");
                                    navigate(".");
                                    setIsOpen(false);
                                })
                                .catch(() => {
                                    toast.error("Une erreur est survenue lors de la modification du commentaire");
                                });
                        }}
                    >
                        Enregistrer
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
